/**
 * Phase model — 10 standard Flemish residential construction phases.
 * Mirror of the seed in docs/mock-data.md and PHASES in
 * bouw-opvolging/project/shared.jsx.
 */

export type PhaseId =
  | 'voor'
  | 'ontw'
  | 'verg'
  | 'aanb'
  | 'ruw'
  | 'wwd'
  | 'tech'
  | 'afw'
  | 'opl'
  | 'naz';

export type Status = 'done' | 'doing' | 'late' | 'idle';

export interface Phase {
  id: PhaseId;
  short: string;
  label: string;
  status: Status;
  start: string;
  end: string;
  progress?: number;
}

export const PHASES: Phase[] = [
  {
    id: 'voor',
    short: 'Voorber.',
    label: 'Voorbereiding',
    status: 'done',
    start: '03/2024',
    end: '06/2024',
  },
  {
    id: 'ontw',
    short: 'Ontwerp',
    label: 'Ontwerp',
    status: 'done',
    start: '06/2024',
    end: '11/2024',
  },
  {
    id: 'verg',
    short: 'Verg.',
    label: 'Vergunningen',
    status: 'done',
    start: '11/2024',
    end: '04/2025',
  },
  {
    id: 'aanb',
    short: 'Aanbest.',
    label: 'Aanbesteding',
    status: 'done',
    start: '02/2025',
    end: '05/2025',
  },
  {
    id: 'ruw',
    short: 'Ruwbouw',
    label: 'Ruwbouw',
    status: 'doing',
    start: '06/2025',
    end: '01/2026',
    progress: 0.62,
  },
  {
    id: 'wwd',
    short: 'W&W-d.',
    label: 'Wind- en waterdicht',
    status: 'doing',
    start: '11/2025',
    end: '03/2026',
    progress: 0.15,
  },
  {
    id: 'tech',
    short: 'Tech.',
    label: 'Technieken',
    status: 'idle',
    start: '02/2026',
    end: '06/2026',
  },
  {
    id: 'afw',
    short: 'Afwerk.',
    label: 'Afwerking',
    status: 'idle',
    start: '05/2026',
    end: '10/2026',
  },
  {
    id: 'opl',
    short: 'Opl.',
    label: 'Oplevering',
    status: 'idle',
    start: '10/2026',
    end: '11/2026',
  },
  { id: 'naz', short: 'Nazorg', label: 'Nazorg', status: 'idle', start: '11/2026', end: '11/2036' },
];

export const STATUS_LABEL: Record<Status, string> = {
  done: 'Afgerond',
  doing: 'Bezig',
  late: 'Vertraagd',
  idle: 'Te starten',
};

export const STATUS_KIND: Record<Status, 'ok' | 'warn' | 'bad' | 'idle'> = {
  done: 'ok',
  doing: 'warn',
  late: 'bad',
  idle: 'idle',
};

export function currentPhase(): Phase {
  return PHASES.find((p) => p.id === 'ruw') ?? PHASES[0];
}
